<template>
  <div
    :class="{
      active: opened,
      'confirmation--centered': centered
    }"
    class="confirmation"
  >
    <div class="confirmation__overlay"/>
    <div class="confirmation__box">
      <div class="confirmation__box__text">
        <div class="d-flex align-items-center">
          <h4 class="font-weight-bolder mb-3">
            {{ $t("necoSeNepovedlo") }}
          </h4>
        </div>
        <ul class="mb-6">
          <li
            v-for="(item, index) in errors"
            :key="index"
            class="text-left gray-text-light mb-0 text-small"
          >
            <p class="mb-0">
              {{ $t(item) }}
            </p>
          </li>
        </ul>
      </div>
      <div
        class="confirmation__box__buttons d-flex align-items-center justify-content-end"
        style="gap: 20px"
      >
        <button
          v-if="showCreateProjectButton && canCreateNewProject && customerId"
          class="btn btn-primary"
          @click="openProjectCreation()"
        >
          {{ $t("CREATE_PROJECT") }}
        </button>
        <button class="btn btn-primary" @click="close()">
          {{ $t("ok") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/store/modules/auth"
import { useCustomerStore } from "@/store/modules/customer"

export default {
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    opened: Boolean,
    centered: Boolean,
    showCreateProjectButton: Boolean
  },
  setup() {
    const authStore = useAuthStore()
    const customerStore = useCustomerStore()

    return { authStore, customerStore }
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    canCreateNewProject() {
      return this.authStore.apiUser?.isCustomerAdmin || this.authStore.apiUser?.isIotAdmin
    },
    customerId() {
      return this.customerStore.selectedCustomer?.customerId
    }
  },
  methods: {
    openProjectCreation() {
      /**
       * customerId has to be passed explicitly: this modal also shows on routes that carry
       * no params (e.g. the welcome page), and there would be nothing to inherit. projectId
       * stays out — the admin menu route treats it as optional exactly for this case.
       */
      this.$router.push({
        name: "admin",
        params: { customerId: this.customerId },
        query: { createProject: true }
      })
      this.close()
    },
    close() {
      this.$emit("close")
    }
  }
}
</script>

<style lang="scss" scoped></style>
